import React, { useRef, useState } from "react";
import { ContentContainer } from "../../../components/layout";
import {
  Button,
  DateRangePicker,
  DownloadButton,
  LoadingComponent,
  Modal,
  MultiSelect,
  NoDataFoundTemplate,
  Select,
  Textfield,
} from "../../../components/core";
import { gql, useLazyQuery, useQuery } from "@apollo/client";
import { useEffect } from "react";
import {
  BarChart,
  Bar,
  ResponsiveContainer,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  CartesianGrid,
} from "recharts";
import TabComponent from "../../../components/core/tab";
import DropOffTable from "./drop-off-table";
import {
  QUERY_CHART_DATA,
  QUERY_COMPANY_BRANCHES,
  QUERY_COMPANY_NKCNAME,
  QUERY_DROP_OFF_STATUS_HISTORY,
  QUERY_LOCKER_NAME,
  QUERY_LOCKER_TYPE,
} from "../../../constants/graphql/drop-off-graphql";
import PrimereactDateRange from "../../../components/core/date-range-primereact";
import { formatDateYYYYMMDD } from "../../../algorithms/date";
import { NEWEST_LOCKER_NAME_QUERY } from "../../../features/stay-time-in-locker/stay-time-query/stay-time-graphql";
import { Card } from "primereact/card";
import { Strings } from "../../../constants/strings";

export const maxDate = (() => {
  const d = new Date();
  d.setMonth(d.getMonth() - 6);
  return d;
})();

const DropOffStatusHistory = () => {
  // local Variables
  const operatorId = JSON.parse(localStorage.getItem("user")).operator_id;
  const [dropOffStatusHistory, setDropOffStatusHistory] = useState([]);
  const [isLoading, setisLoading] = useState(false);

  const [dontShowChart, setdontShowChart] = useState(false);

  //<SELECT> data to be queued

  const [filterVariables, setFilterVariables] = useState({
    lockerType: "-1",
    selectedLockerName: [],

    startDate: (() => {
      const d = new Date();
      d.setMonth(d.getMonth() - 6);
      return d;
    })(),
    endDate: new Date(),
    selectedStatus: "-1",
    selectedPartnerCompany: "-1",
    selectedPartnerBranch: [],
    selectedRadio: "weekday",
  });

  // queued variaballs
  const [lockerName, setLockerName] = useState([]);
  const [selectedRadio, setSelectedRadio] = useState("weekday");
  const [allLockersSelected, setAllLockersSelected] = useState(false);
  const [noResultSearch, setNoResultSearch] = useState(false);
  const [chartData, setChartData] = useState([]);

  const [isTableEmpty, setIsTableEmpty] = useState(false);
  const dt = useRef(null);

  const dropStatus = [
    { value: "200", name: "-- ALL --" },
    { value: "128", name: "Claimed" },
    { value: "110", name: "Pending" },
    { value: "121", name: "Overstay" },
    { value: "130", name: "For Collect" },
    { value: "138", name: "Revoked" },
    { value: "118", name: "Removed" },
    { value: "150", name: "Cancelled" },
  ];

  const [validation, setValidation] = useState({
    icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
    title: "",
    message: "",
    open: false,
  });

  function formatDate(inputDate) {
    if (inputDate == null) {
      return "";
    }
    const date = new Date(inputDate);
    const options = { year: "numeric", month: "short", day: "numeric" };
    return date.toLocaleDateString(undefined, options);
  }

  //GraphQL queries
  const [QUERYdropOffStatusHistory, { data, loading }] = useLazyQuery(
    QUERY_DROP_OFF_STATUS_HISTORY,
    { fetchPolicy: "no-cache" }
  );

  const handleFilterChange = (e, field) => {
    let value = e.target.value;
    if (field === "startDate" || field === "endDate") {
      value = value ? new Date(value) : null;
    }

    // If changing partner company, also clear partner branch
    if (field === "selectedPartnerCompany") {
      setFilterVariables({
        ...filterVariables,
        [field]: value,
        selectedPartnerBranch: [], // Clear partner branch when company changes
      });
    } else if (field === "lockerType") {
      setFilterVariables({
        ...filterVariables,
        [field]: value,
        selectedLockerName: [], // Clear partner branch when company changes
      });
    } else {
      setFilterVariables({
        ...filterVariables,
        [field]: value,
      });
    }
  };

  const [fetchChartData, resultFetchChartData] = useLazyQuery(
    QUERY_CHART_DATA,
    { fetchPolicy: "no-cache" }
  );
  const fetchLockerType = useQuery(QUERY_LOCKER_TYPE);
  const [fetchLockerName, { data: lockerNameData }] = useLazyQuery(
    NEWEST_LOCKER_NAME_QUERY,
    {
      variables: {
        operatorId: operatorId,
        //   selectedLockerType: selectedLockerType,
      },
    }
  );
  const fetchCompanyName = useQuery(QUERY_COMPANY_NKCNAME, {
    variables: {
      operatorId: operatorId,
    },
  });
  const [fetchCompanyBranch, { data: companyBranchData }] = useLazyQuery(
    QUERY_COMPANY_BRANCHES,
    {
      variables: {
        operatorId: operatorId,
        //   selectedLockerType: selectedLockerType,
      },
    }
  );

  //To Fetch Table Data
  useEffect(() => {
    if (data) {
      if (data.packageDropoffStatusHistory.length == 0) {
        setisLoading(false);
        setNoResultSearch(true);
        setIsTableEmpty(true);
        return;
      }
      let tempData = [];
      data.packageDropoffStatusHistory.forEach((element) => {
        let obj = { ...element };
        // Format statusDate with a comma after the day
        const [year, month, day] = obj.statusDate.split("-");
        obj.statusDate = `${year} ${month}, ${day}`;
        // Format statusDate with a comma after the day
        const [year1, month2, day2] = obj.dropoff.split("-");
        obj.dropoff = `${year1} ${month2}, ${day2}`;
        obj.waybill = checkIfDigitsOnly(obj.waybill);
        tempData.push(obj);
      });
      setDropOffStatusHistory(tempData);
      setisLoading(false);
    }
  }, [data]);

  function checkIfDigitsOnly(waybill) {
    if (/^\d+$/.test(waybill)) {
      // return waybill + '*';
      return waybill.slice(0, 1) + "*" + waybill.slice(1);
    }
    return waybill;
  }

  useEffect(() => {
    if (
      resultFetchChartData.data &&
      resultFetchChartData.data.packageDropoffStatus
    ) {
      const tempData = resultFetchChartData.data.packageDropoffStatus.map(
        (element) => ({
          name: element.date,
          Claimed: element.statusClaimed,
          Pending: element.statusPending,
          Overstay: element.statusOverstay,
          Revoked: element.statusRevoked,
          TakeBack: element.statusTakeback,
          Removed: element.statusRemoved,
          Total:
            element.statusClaimed +
            element.statusPending +
            element.statusOverstay +
            element.statusRevoked +
            element.statusTakeback +
            element.statusRemoved,
        })
      );

      setChartData(tempData);
    }
  }, [resultFetchChartData.data]);

  // Calculate totals for each category
  const totals = chartData.length
    ? chartData.reduce(
        (acc, cur) => {
          acc.Claimed += cur.Claimed || 0;
          acc.Pending += cur.Pending || 0;
          acc.Overstay += cur.Overstay || 0;
          acc.Removed += cur.Removed || 0;
          acc.TakeBack += cur.TakeBack || 0;
          acc.Cancelled += cur.Cancelled || 0;
          acc.Revoked += cur.Revoked || 0;
          acc.Total += cur.Total;
          return acc;
        },
        {
          Claimed: 0,
          Pending: 0,
          Overstay: 0,
          Removed: 0,
          TakeBack: 0,
          Cancelled: 0,
          Revoked: 0,
          Total: 0,
        }
      )
    : {
        Claimed: 0,
        Pending: 0,
        Overstay: 0,
        Removed: 0,
        TakeBack: 0,
        Cancelled: 0,
        Revoked: 0,
        Total: 0,
      };
  //To Fetch Company Branches
  const [partnerBranch, setPartnerBranch] = useState([]);
  const [allBranchesSelected, setAllBranchesSelected] = useState(false);

  useEffect(() => {
    if (filterVariables.selectedPartnerCompany !== "-1") {
      fetchCompanyBranch({
        variables: {
          operatorId: operatorId,
          selectedPartnerCompany: filterVariables.selectedPartnerCompany,
        },
      });
    }
  }, [filterVariables.selectedPartnerCompany, operatorId]);

  useEffect(() => {
    if (companyBranchData && companyBranchData.searchBranches) {
      const tempData = companyBranchData.searchBranches.map((element) => ({
        value: element.partnerBranchId,
        label: element.partnerBranch,
      }));

      // Add "All Branches" option
      if (!allBranchesSelected) {
        tempData.unshift({
          value: 0,
          label: "All Partner Branches",
        });
      }
      setPartnerBranch(tempData);
    }
  }, [companyBranchData, allBranchesSelected]);
  useEffect(() => {
    const selected = filterVariables.selectedPartnerBranch;
    const allBranches = partnerBranch;

    const hasZeroValue = selected.some((item) => item.value === 0);

    if (hasZeroValue) {
      setAllBranchesSelected(true);
    } else if (selected.length === 0) {
      setAllBranchesSelected(false);
    } else if (selected.length !== allBranches.length) {
      setAllBranchesSelected(false);
    } else {
      setAllBranchesSelected(true);
    }
  }, [filterVariables.selectedPartnerBranch, partnerBranch]);

  useEffect(() => {
    if (allBranchesSelected) {
      const branches = partnerBranch.filter((branch) => branch.value !== 0);

      setFilterVariables({
        ...filterVariables,
        selectedPartnerBranch: branches,
      });
    }
  }, [allBranchesSelected, partnerBranch]);

  //To Fetch Company Name
  const [partnerCompany, setPartnerCompany] = useState("");
  useEffect(() => {
    if (fetchCompanyName.data) {
      let tempData = [];
      fetchCompanyName.data.partners.forEach((element, index) => {
        tempData.push({
          value: element.partnerId,
          name: element.companyNickname,
        });
      });
      setPartnerCompany(tempData);
    }
  }, [fetchCompanyName.data]);

  //to fetch lockerType
  const [lockerType, setLockerType] = useState();
  useEffect(() => {
    if (fetchLockerType.data) {
      let tempData = [];
      fetchLockerType.data.lockerTypes.forEach((element, index) => {
        tempData.push({
          value: element.lockerTypeId,
          name: element.lockerType,
        });
      });
      setLockerType(tempData);
    }
  }, [fetchLockerType.data]);

  //To Fetch Locker Name
  useEffect(() => {
    if (filterVariables.lockerType !== "-1") {
      fetchLockerName({
        variables: {
          operatorId: operatorId,
          lockerTypeId: filterVariables.lockerType,
        },
      });
    }
  }, [filterVariables.lockerType, operatorId]);

  useEffect(() => {
    if (lockerNameData) {
      const tempData = lockerNameData.lockerInfo.map((element) => ({
        label: element.lockerName,
        value: element.lockerId,
      }));

      if (!allLockersSelected) {
        tempData.unshift({
          value: 0,
          label: "All Lockers",
        });
      }

      setLockerName(tempData);
    }
  }, [lockerNameData, allLockersSelected]);

  useEffect(() => {
    const selected = filterVariables.selectedLockerName;
    const allLockers = lockerName;

    const hasZeroValue = selected.some((item) => item.value === 0);

    if (hasZeroValue) {
      setAllLockersSelected(true);
    } else if (selected.length === 0) {
      setAllLockersSelected(false);
    } else if (selected.length !== allLockers.length) {
      setAllLockersSelected(false);
    } else {
      setAllLockersSelected(true);
    }
  }, [filterVariables.selectedLockerName, lockerName]);
  useEffect(() => {
    if (allLockersSelected) {
      const selectedLockers = lockerName.filter((locker) => locker.value !== 0);

      setFilterVariables({
        ...filterVariables,
        selectedLockerName: selectedLockers,
      });
    }
  }, [allLockersSelected, lockerName]);

  //Search handler
  const [searchResultHeader, setSearchResultHeader] = useState();

  function handleSearchResultHeader() {
    const lockerTypeName =
      filterVariables.lockerType === "-1"
        ? "ALL Locker types"
        : filterVariables.lockerType === "1"
        ? "Parcel Locker"
        : "Fridge Locker";

    let lockerNameText;
    if (allLockersSelected) {
      lockerNameText = "ALL Lockers";
    } else {
      const lockerLabels = filterVariables.selectedLockerName
        .map((selectedLocker) => {
          const matchedLocker = lockerName.find(
            (item) => parseInt(item.value) === parseInt(selectedLocker.value)
          );
          return matchedLocker ? matchedLocker.label : null;
        })
        .filter((label) => label !== null);

      lockerNameText =
        lockerLabels.length > 0 ? lockerLabels.join(", ") : "ALL Lockers";
    }

    const partnerCompanyName =
      filterVariables.selectedPartnerCompany === "-1"
        ? "All Partners"
        : partnerCompany.find(
            (item) => item.value === filterVariables.selectedPartnerCompany
          )?.name;

    // const partnerBranchValue =
    //   filterVariables.selectedPartnerBranch === 0 ||
    //   filterVariables.selectedPartnerBranch === ""
    //     ? "All Branches"
    //     : partnerBranch.find(
    //         (item) => item.value === filterVariables.selectedPartnerBranch
    //       );

    // const partnerBranchText = partnerBranchValue
    //   ? partnerBranchValue.name
    //   : "ALL Branches";

    console.log({ allBranchesSelected });
    let partnerBranchText;
    if (allBranchesSelected) {
      partnerBranchText = "ALL Branches";
    } else {
      const branchLabels = filterVariables.selectedPartnerBranch
        .map((sB) => {
          const matchedBranch = partnerBranch.find(
            (item) => parseInt(item.value) === parseInt(sB.value)
          );
          return matchedBranch ? matchedBranch.label : null;
        })
        .filter((label) => label !== null);

      partnerBranchText =
        branchLabels.length > 0 ? branchLabels.join(", ") : "ALL Branches";
    }

    setSearchResultHeader(`for
      ${lockerTypeName},
      ${lockerNameText},
      ${partnerCompanyName},
      ${partnerBranchText},
	  from ${formatDate(filterVariables.startDate)} to ${formatDate(
      filterVariables.endDate
    )}
    `);
  }
  //Search Button
  const handleTabClick = (tabValue) => {
    // setSelectedRadio(tabValue);
    setFilterVariables({
      ...filterVariables,
      selectedRadio: tabValue,
    });
  };

  useEffect(() => {
    const ChartVariable = buildVariables(true);
    fetchChartData({
      variables: ChartVariable,
    });
  }, [filterVariables.selectedRadio]);
  const buildVariables = (forCharData = false) => {
    const start = formatDateYYYYMMDD(filterVariables.startDate);
    const end = formatDateYYYYMMDD(filterVariables.endDate);

    const updatedVariables = {
      operatorId: operatorId,
      dateStart: start,
      dateEnd: end,
    };

    // append selectedradio only for chart data
    if (forCharData) {
      updatedVariables.selectedRadio = filterVariables.selectedRadio;
    }

    // Check each state and add to updatedVariables if not empty
    if (filterVariables.selectedStatus !== "-1") {
      updatedVariables.selectedStatus = parseInt(
        filterVariables.selectedStatus
      );
    }

    if (filterVariables.selectedLockerName.length !== 0) {
      // if (selectedLockerName != "200") {
      const lockerIdValues = filterVariables.selectedLockerName.map(
        (locker) => locker.value
      );

      updatedVariables.selectedLockerName = lockerIdValues;
      // }
    }
    if (filterVariables.selectedPartnerCompany !== "-1") {
      updatedVariables.selectedPartnerCompany = parseInt(
        filterVariables.selectedPartnerCompany
      );
    }

    if (filterVariables.selectedPartnerBranch.length !== 0) {
      const branchVal = filterVariables.selectedPartnerBranch.map(
        (locker) => locker.value
      );

      updatedVariables.selectedPartnerBranch = branchVal;
    }

    return updatedVariables;
  };
  // Validation helper function
  const showValidationModal = (title, message) => {
    setValidation({
      icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
      title,
      message,
      open: true,
      actions: (
        <div className="w-full">
          <Button
            onClick={() => setValidation({ open: false })}
            value={"OK"}
            className={"p-2 w-full"}
          />
        </div>
      ),
    });
    setisLoading(false);
  };

  // Validation rules
  const validateFilters = () => {
    const {
      lockerType,
      selectedLockerName,
      selectedPartnerCompany,
      selectedPartnerBranch,
      startDate,
      endDate,
    } = filterVariables;

    // Locker validation
    if (lockerType !== "-1" && selectedLockerName.length === 0) {
      showValidationModal(
        `${Strings.popup_error_title_search_criteria}`,
        `${Strings.popup_error_lockername}`
      );
      return false;
    }

    // Partner branch validation
    if (selectedPartnerCompany !== "-1" && selectedPartnerBranch.length === 0) {
      showValidationModal(
        `${Strings.popup_error_title_search_criteria}`,
        "Please select a partner branch."
      );
      return false;
    }

    // Date validation
    if (!startDate && !endDate) {
      showValidationModal("Invalid Date", "Please select a date range.");
      return false;
    }

    if (!startDate) {
      showValidationModal("Invalid Date", "No start date selected.");
      return false;
    }

    if (!endDate) {
      showValidationModal("Invalid Date", "No end date selected.");
      return false;
    }

    if (startDate > endDate) {
      showValidationModal(
        "Invalid Date",
        "Start date must be before end date."
      );
      return false;
    }

    return true;
  };

  // Modal Handler
  function EmptyCriteriaHandler(e) {
    const TableVariables = buildVariables(false);
    const ChartVariable = buildVariables(true);

    if (
      filterVariables.lockerType !== "-1" &&
      filterVariables.selectedLockerName.length === 0
    ) {
      setDropOffStatusHistory([]);
      setisLoading(false);
      setNoResultSearch(true);
      showValidationModal("Invalid Locker", "Please select a locker name.");
    } else if (
      filterVariables.lockerType === "2" &&
      filterVariables.selectedLockerName.length === 1
    ) {
      setisLoading(false);
      setChartData([]);
      setIsTableEmpty(true);
    } else {
      fetchChartData({
        variables: ChartVariable,
      });
      QUERYdropOffStatusHistory({
        variables: TableVariables,
      });
      setNoResultSearch(false);
      setIsTableEmpty(false);
    }
  }

  // Main search handler
  const handleSearch = (event, data) => {
    setisLoading(true);
    setChartData([]);
    handleSearchResultHeader();
    setDropOffStatusHistory([]);

    setFilterVariables({
      ...filterVariables,
      selectedRadio: "weekday",
    });

    // Validate all filters
    if (!validateFilters()) {
      return; // Exit early if validation fails
    }

    // If validation passes, proceed with the search
    EmptyCriteriaHandler();
  };

  return (
    <ContentContainer containerTitle={"Dropoff Status and History Report"}>
      <h2 className={"font-bold"}>Locker:</h2>
      <div className={"grid grid-cols-6 w-full gap-y-2"}>
        <p className="col-span-1">Locker Type:</p>
        <Select
          items={lockerType}
          className={"col-span-3"}
          value={filterVariables.lockerType}
          defaultOption={{ value: "-1", name: "-- ALL--" }}
          onChange={(event) => {
            // setAllLockersSelected(false);
            setFilterVariables({
              ...filterVariables,
              selectedLockerName: [],
            });

            handleFilterChange(event, "lockerType");
          }}
        />
        <div className="col-span-2"></div>
        <p className="col-span-1">Locker Name:</p>
        <MultiSelect
          items={lockerName}
          className={"col-span-3"}
          value={filterVariables.selectedLockerName}
          placeholder={`${
            filterVariables.lockerType === "-1" ? "ALL Lockers" : "Select..."
          }`}
          disabled={filterVariables.lockerType === "-1"}
          onChange={(event) => {
            handleFilterChange(event, "selectedLockerName");
          }}
        />
      </div>

      {/* status */}
      <div className={"grid grid-cols-6 w-full gap-y-2 mt-5"}>
        <h2 className={"font-bold col-span-1"}>Status:</h2>
        <Select
          items={dropStatus}
          className={"col-span-3"}
          value={filterVariables.selectedStatus}
          onChange={(event) => {
            handleFilterChange(event, "selectedStatus");
          }}
        />
      </div>

      {/* by partner */}
      <h2 className={"font-bold"}>Partner</h2>
      <div className={"grid grid-cols-6 w-full items-center gap-y-2"}>
        <p className="col-span-1">Partner Company:</p>
        <Select
          items={partnerCompany}
          className={`col-span-3`}
          value={filterVariables.selectedPartnerCompany}
          defaultOption={{ value: "-1", name: "-- ALL --" }}
          onChange={(event) => {
            handleFilterChange(event, "selectedPartnerCompany");
          }}
        />
        <div className="col-span-2"></div>

        <p>Partner Branch:</p>
        <MultiSelect
          items={partnerBranch}
          className={`col-span-3`}
          value={filterVariables.selectedPartnerBranch}
          placeholder={`${
            filterVariables.selectedPartnerCompany === "-1"
              ? "ALL Partner Branches"
              : "Select..."
          }`}
          disabled={
            filterVariables.selectedPartnerCompany !== "-1" ? false : true
          }
          onChange={(event) => {
            handleFilterChange(event, "selectedPartnerBranch");
          }}
        />
      </div>

      <h2 className={"font-bold pt-3 pb-2"}>Date range:</h2>

      <PrimereactDateRange
        className={"w-1/2"}
        startDate={filterVariables.startDate}
        endDate={filterVariables.endDate}
        readOnlyInput={true}
        max={new Date()}
        min={new Date("2021-01-01")}
        startDateName="startDate"
        endDateName="endDate"
        timeOnly={false}
        onChange={(event, fieldName) => {
          handleFilterChange(event, fieldName);
        }}
      />
      <div className="grid grid-cols-2 w-1/2 gap-y-2">
        <div></div>
        <u
          className="flex hover:text-blue-500 cursor-pointer mt-4 ml-auto w-min"
          onClick={() => {
            setFilterVariables({
              ...filterVariables,
              startDate: maxDate,
              endDate: new Date(),
              selectedLockerName: [],
              lockerType: "-1",
              selectedStatus: "-1",
              selectedPartnerCompany: "-1",
              selectedPartnerBranch: [],
            });
          }}
        >
          <i className="fas fa-undo my-auto"></i>
          <p className="ml-1">Reset</p>
        </u>
      </div>

      <Button
        value={"SEARCH"}
        onClick={(event) => {
          setisLoading(true);
          handleSearch(event, data);
        }}
        className={"w-40 h-8 m-5"}
      />
      {isLoading && <LoadingComponent />}
      {dropOffStatusHistory.length > 0 && noResultSearch == false && (
        <div className="px-4">
          <Card className="">
            <DownloadButton dt={dt} id={"Dropoff Status History"} />
            <div className="border border-black">
              {!dontShowChart && (
                <div id={"Dropoff Status History"}>
                  <div className={"grid grid-row-3 bg-yellow-400 p-2"}>
                    <div>
                      <TabComponent
                        tabs={[
                          {
                            value: "daily",
                            title: "Daily",
                          },
                          {
                            value: "weekly",
                            title: "Weekly",
                          },
                          {
                            value: "weekday",
                            title: "Day of the Week",
                          },
                          {
                            value: "monthly",
                            title: "Monthly",
                          },
                          {
                            value: "yearly",
                            title: "Yearly",
                          },
                        ]}
                        onTabClick={handleTabClick}
                      />
                    </div>
                    <div className={"text-center"}>
                      <span>
                        <h1 className={"font-bold"}>DROPOFF STATUS HISTORY</h1>
                      </span>
                      <span>
                        <h1 className={"font-bold"}>{searchResultHeader}</h1>
                      </span>
                    </div>
                  </div>
                  <ResponsiveContainer width={"100%"} height={500}>
                    <BarChart
                      className="mx-auto"
                      width={900}
                      height={400}
                      data={chartData}
                      margin={{ top: 5, right: 30, left: 20, bottom: 10 }}
                    >
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis dataKey="name" />
                      <YAxis />
                      <Tooltip
                        formatter={(value, name, props) => {
                          if (name === "TakeBack") {
                            return [value, "For Collect"];
                          }
                          if (name === "Revoked") {
                            // Compute the total for all fields
                            const total = Object.keys(props.payload).reduce(
                              (sum, key) => {
                                if (
                                  [
                                    "Claimed",
                                    "Pending",
                                    "Overstay",
                                    "Removed",
                                    "TakeBack",
                                    "Cancelled",
                                    "Revoked",
                                  ].includes(key)
                                ) {
                                  return sum + (props.payload[key] || 0);
                                }
                                return sum;
                              },
                              0
                            );

                            return [
                              <>
                                {value}
                                <br />
                                <p style={{ color: "#000" }}>Total: {total}</p>
                              </>,
                              "Revoked",
                            ];
                          }
                          return [value, name];
                        }}
                      />

                      <Legend
                        layout="vertical"
                        verticalAlign="top"
                        formatter={
                          (value) => {
                            if (value == "Revoked") {
                              return [
                                <>
                                  Revoked: {totals[value]}
                                  <br />
                                  <p style={{ color: "#000" }}>
                                    Total: {totals.Total}
                                  </p>
                                </>,
                              ];
                            } else {
                              if (value == "TakeBack") {
                                return `For Collect :${totals[value]}`;
                              } else {
                                return `${value} :${totals[value]}`;
                              }
                            }
                          }
                          // `${value == "Total" ? "" : value == "TakeBack" ? "Take-Back" : value} Total: ${totals[value]
                          // }`
                        }
                      />
                      <Bar dataKey={"Claimed"} stackId={"a"} fill="#4CBB17" />
                      <Bar dataKey={"Pending"} stackId={"a"} fill="#FFBF00" />
                      <Bar dataKey={"Overstay"} stackId={"a"} fill="#D36E70" />
                      <Bar dataKey={"Removed"} stackId={"a"} fill="#4E5754" />
                      <Bar dataKey={"TakeBack"} stackId={"a"} fill="#3F888F" />
                      <Bar dataKey={"Cancelled"} stackId={"a"} fill="#AEA04B" />
                      <Bar dataKey={"Revoked"} stackId={"a"} fill="#FF5733" />
                      {/* <Bar dataKey={"Total"} stackId={"a"} /> */}
                    </BarChart>
                  </ResponsiveContainer>
                </div>
              )}

              <DropOffTable
                headers={[
                  {
                    header_name: "Locker Name",
                    header_key: "locker",
                  },
                  {
                    header_name: "Waybill Number",
                    header_key: "waybill",
                  },
                  {
                    header_name: "Recipient",
                    header_key: "recipient",
                  },
                  {
                    header_name: "Dropoff",
                    header_key: "dropoff",
                  },
                  {
                    header_name: "Status",
                    header_key: "status",
                  },
                  {
                    header_name: "Status Date",
                    header_key: "statusDate",
                  },
                  {
                    header_name: "Hrs Elapsed",
                    header_key: "elapsedHrs",
                  },
                  {
                    header_name: "Courier",
                    header_key: "courier",
                  },
                  {
                    header_name: "",
                    header_key: "actionButton",
                  },
                  {
                    header_name: searchResultHeader,
                    header_key: "blank",
                  },
                ]}
                items={dropOffStatusHistory}
                dt={dt}
              />
            </div>
          </Card>
        </div>
      )}

      {isTableEmpty ? <NoDataFoundTemplate /> : ""}

      <Modal
        icon={validation.icon}
        title={validation.title}
        message={validation.message}
        open={validation.open}
        actions={validation.actions}
      />
    </ContentContainer>
  );
};

export default DropOffStatusHistory;
